export default __webpack_public_path__ + "static/nav-banner-credit-c75e21b8ce1ecbaa79d6df806211e3ea.webp";